import './App.css';
import { BrowserRouter, Routes, Route} from "react-router-dom";
import OnboardingProcess2 from './Component/OnboardingProcess/OnboardingProcess';
import ThankYouPage from './Util/ThankyouPage';
import PaymentFailedPage from './Util/PaymentFailedPage';
console.log = () => {}
console.error = () => {} 
console.warn=()=>{}
function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<OnboardingProcess2 />} />
      <Route path="/paymentsuccess" element={<ThankYouPage />} />
      <Route path="/paymentFail" element={<PaymentFailedPage/>}/>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
